<template>
  <v-dialog v-model="dialogsukseskan" persistent max-width="500">
    <v-card>
      <v-card-title class="heading primary white--text">Sukseskan Trx</v-card-title>
      <v-card-text class="mt-4">
        <v-text-field readonly disabled label="IdTrx" v-model="selectedtrx.id"></v-text-field>
        <v-text-field readonly disabled label="Waktu" v-model="waktutrx"></v-text-field>
        <v-text-field readonly disabled label="Penjual" v-model="selectedtrx.sellername"></v-text-field>
        <v-text-field readonly disabled label="Pembeli" v-model="selectedtrx.membername"></v-text-field>
        <v-text-field label="Keterangan" v-model="selectedtrx.description"></v-text-field>
        <v-text-field autofocus label="SerialNumber" v-model="selectedtrx.serialnumber"></v-text-field>
      </v-card-text>
      <v-divider/>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn elevation="0" color="red darken-1" dark @click.native="setdialogsukseskan(false)">Batal</v-btn>
        <v-btn elevation="0" color="primary darken-1"  @click.native="doSukseskan">Sukseskan</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'DialogSukseskanTrx',
  data: () => ({

  }),
  computed: {
    ...mapState('TrxAdmin', ['selectedtrx', 'dialogsukseskan']),
    waktutrx: {
      get: function () {
        return this.formatDate(this.selectedtrx.createat)
      }
    }
  },
  methods: {
    ...mapActions('TrxAdmin', ['setdialogsukseskan', 'sukseskanTrx']),
    doSukseskan () {
      this.sukseskanTrx({
        id: this.selectedtrx.id,
        serialnumber: this.selectedtrx.serialnumber,
        description: this.selectedtrx.description,
        status: this.selectedtrx.transactionrc
      })
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    }
  }
}
</script>

<style scoped>

</style>
